// remove once the aggregate eu goodbye page is removed as well!
export const isAggregateEuActive = (pathname: string) =>
  pathname.startsWith('/aggregate-eu');
